module.exports = __webpack_public_path__ + "img/75681.fc1a368f.svg";